import { useState, useContext, useEffect } from 'react';
import moment from "moment";
import { RadioGroup } from "@headlessui/react";
import { CheckCircleIcon } from "@heroicons/react/20/solid";
import { calcularFechas } from '../credits/calculoFechas';
import { calcularTotalCuotaSimulador } from '../../utils/calcularTotalCuotaSimulador';
import { OfertaViewContext } from '../../context/OfertaContext/OfertaViewContext';
import { getInterest } from '../../utils/creditUser/getInterest';


function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

const fechasOptions = calcularFechas();

const dateLimit1 = fechasOptions.fecha1.format("DD/MM/YYYY");
const dateLimit2 = fechasOptions.fecha2.format("DD/MM/YYYY");
const vence1 = fechasOptions.fecha1.diff(moment(), "days");
const vence2 = fechasOptions.fecha2.diff(moment(), "days");

const timepay = [
    { id: 1, value: vence1 + 1 },
    { id: 2, value: vence2 + 1 },
];


const datepay = [
    {
        id: 1,
        day: fechasOptions.fecha1Day,
        datelimit: dateLimit1,
        value: timepay[0].value,
        expira: `Vence en ${timepay[0].value} días`,
    },
    {
        id: 2,
        day: fechasOptions.fecha2Day,
        datelimit: dateLimit2,
        value: timepay[1].value,
        expira: `Vence en ${timepay[1].value} días`,
    },
];


export function FechasRadioGroup({ amount = 200000, creditUser, updateCreditUser }) {

    const { updateOfertaView } = useContext(OfertaViewContext);
    const [Amount] = useState(amount);
    const [selectedMailingLists, setSelectedMailingLists] = useState({});
    const [tasa, setTasa] = useState(localStorage.getItem("currentInterestRate"));

    const admon = 60000;

    useEffect(() => {
        const cargarTasa = async () => {
            await getInterest();
            setTasa(localStorage.getItem("currentInterestRate"));
        };
        if (!tasa) cargarTasa();
    }, [tasa]);

    const handleChangeOption = (event) => {
        event.persist();
        const target = event.target;
        let dateSelected = moment(target.innerText, "DD/MM/YYYY");
        let vencimientoEnDias = dateSelected.diff(moment(), "days") + 1;
        //Calcular el total de la cuota
        let total = calcularTotalCuotaSimulador({
            vencimientoEnDias,
            Amount,
            admon,
            tasa
        });

        updateOfertaView({
            credit_id: creditUser.credit_id,
            approvedQuota: creditUser.approvedQuota,
            termInDays: vencimientoEnDias,
            totalToPay: total,
            paydayLimit: target.innerText,
            documento: creditUser?.documento || localStorage.getItem('doc'),
            approvedDate: creditUser.approvedDate
        })
    };

    useEffect(() => {
        datepay.forEach((datePay, index) => {
            if (datePay.datelimit === creditUser?.paydayLimit) {
                setSelectedMailingLists(datepay[index]);
            }
        })
    }, [creditUser?.paydayLimit])


    return (
        <RadioGroup
            value={selectedMailingLists}
            onChange={setSelectedMailingLists}
        >
            <div className="mt-0 grid gap-y-6 grid-cols-2 gap-x-4">
                {datepay.map((datePay, index) => (
                    <RadioGroup.Option
                        onClick={handleChangeOption}
                        value={datePay}
                        key={datePay.id}
                        className={({ checked, active }) =>
                            classNames(
                                checked
                                    ? "border-transparent"
                                    : "border-purpleLight border-2",
                                active ? "border-purple border-2" : "",
                                "relative border-2 rounded-lg shadow-xs px-2 py-1 flex cursor-pointer"
                            )
                        }
                    >
                        {({ checked, active }) => (
                            <>
                                
                                    <span key={`${index}-span-child1`} className="flex flex-col">
                                        <RadioGroup.Description

                                            as="span"
                                            className="flex font-medium items-center text-xl cursor-pointer"
                                        >
                                            {datePay.datelimit} {/* Fecha limite de pago */}
                                        </RadioGroup.Description>
                                    </span>
                      
                                <CheckCircleIcon
                                    className={classNames(
                                        !checked ? "invisible" : "",
                                        "h-5 w-5 pt-1 text-green"
                                    )}
                                    style={{position:'absolute', right:5}}
                                    aria-hidden="true"
                                />
                                <span
                                    key={`${index}-span-root2`}
                                    className={classNames(
                                        active ? "border-purple border-2" : "border-2",
                                        checked ? "border-purple" : "border-transparent",
                                        "absolute -inset-px rounded-lg pointer-events-none"
                                    )}
                                    aria-hidden="true"
                                />
                            </>
                        )}
                    </RadioGroup.Option>
                ))}
            </div>
        </RadioGroup>
    )
}